import { render, staticRenderFns } from "./Foxintelligence.vue?vue&type=template&id=57990a27&scoped=true&"
import script from "./Foxintelligence.vue?vue&type=script&lang=js&"
export * from "./Foxintelligence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57990a27",
  null
  
)

export default component.exports